<template>
  <div>
    <v-expansion-panels>
      <OfferImagePanel image-type="swayOffer" :image-url="swayOffer.offer_image_url" @save="handleUpdateSwayOffer" />

      <OfferSocialsPanel
        :hashtags="swayOffer.hashtags"
        :instagram-mentions="swayOffer.instagram_mentions"
        :facebook-mentions="swayOffer.facebook_mentions"
        @save="handleUpdateSwayOffer"
      />

      <SwayOfferUrlPanel :sway-offer-id="swayOffer.id" :short-url-id="swayOffer.short_url_id" />

      <template v-if="isAdmin">
        <OfferSummaryPanel :offer-summary="swayOffer.offer_summary" @save="handleUpdateSwayOffer" />

        <SwayOfferAdminPanel
          :offer-type="swayOffer.offer_type"
          :fine-print="swayOffer.fine_print"
          :fine-print-url="swayOffer.fine_print_url"
          :expiration-description="swayOffer.expiration_description"
          :approve-proof-email-template-id="swayOffer.approve_proof_email_template_id"
          :deny-proof-email-template-id="swayOffer.deny_proof_email_template_id"
          @save="handleUpdateSwayOffer"
        />
      </template>
    </v-expansion-panels>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

import OfferImagePanel from '@/components/Offers/OfferPanels/OfferImagePanel'
import OfferSocialsPanel from '@/components/Offers/OfferPanels/OfferSocialsPanel'
import SwayOfferAdminPanel from '@/components/Offers/OfferPanels/SwayOfferAdminPanel'
import OfferSummaryPanel from '@/components/Offers/OfferPanels/OfferSummaryPanel'
import SwayOfferUrlPanel from '@/components/Offers/OfferPanels/SwayOfferUrlPanel'

export default Vue.extend({
  name: 'SwayOfferFormBase',

  components: {
    OfferImagePanel,
    OfferSocialsPanel,
    SwayOfferAdminPanel,
    OfferSummaryPanel,
    SwayOfferUrlPanel,
  },

  props: {
    swayOffer: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('account', ['isAdmin']),
  },

  methods: {
    ...mapActions('swayoffer', ['updateSwayOffer']),

    handleUpdateSwayOffer(event) {
      this.updateSwayOffer({ swayOffer: { ...this.swayOffer, ...event } })
    },
  },
})
</script>
